const getDefaultTextHighlightColors = (theme) => [
  { backgroundColor: theme.mainColor, color: theme.mainTextColor },
  { borderColor: theme.mainColor, color: theme.mainColor },
  { backgroundColor: theme.successColor, color: theme.successTextColor },
  {
    backgroundColor: theme.successLightColor,
    color: theme.successLightTextColor
  },
  { borderColor: theme.successColor, color: theme.successColor },
  { backgroundColor: theme.warningColor, color: theme.warningTextColor },
  {
    backgroundColor: theme.warningLightColor,
    color: theme.warningLightTextColor
  },
  { backgroundColor: theme.dangerColor, color: theme.dangerTextColor },
  {
    backgroundColor: theme.dangerLightColor,
    color: theme.dangerLightTextColor
  },
  { borderColor: theme.dangerColor, color: theme.dangerColor }
];

export default getDefaultTextHighlightColors;
